export default "__VITE_ASSET__BVjxXO7i__"